import {
  Component,
  ViewEncapsulation,
  OnInit, Inject, OnDestroy, ViewChild, AfterViewInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult,
  RowArgs, SelectionEvent
} from '@progress/kendo-angular-grid';

import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../../../../services/user-context/user-context';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../../../../services/api/api.service';
import {DOCUMENT} from '@angular/common';
import {Observable, Subscription} from 'rxjs';
import {PublicationDialogComponent} from './publication-dialog.component';
import {PublicationsService} from './publications.service';

@Component({
  selector: 'app-publications',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'publications.template.html'
})
export class PublicationsComponent implements OnInit, OnDestroy {

  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  private selectedPublication: RowArgs;
  public state: State = {
    skip: 0,
    take: 10
  };
  private accountId: string;
  public account: any;

  loading = false;
  public crumbs: any[] = [
    {label: 'Accounts', link: '/accounts'}
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private service: PublicationsService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private userContext: UserContext,
    @Inject(DOCUMENT) private document: Document) {

  }

  public ngOnInit(): void {
    this.view = this.service;
    this.subscription = this.service.subscription;

    this.getPublications();
  }

  public ngOnDestroy(): void {
  }

  public dataPublicationStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getPublications();
  }

  public getPublications() {
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getPublications(page, limit, () => {
      this.loading = false;
    });
  }


  public onPublicationSelection(event: SelectionEvent) {
    this.selectedPublication = event.selectedRows[0];
  }

  public addPublication(): void {
    const dialogRef = this.dialog.open(PublicationDialogComponent, {
      width: '1050px',
      closeOnNavigation: false
    });

    dialogRef.afterClosed().subscribe(publication => {

      if ( publication ) {
        publication.account = this.accountId;
        this.api.post<any>(`/account/${this.accountId}/publication`, publication ).subscribe( result => {
          this.snackBar.open('Publication added.', null, {
            duration: 2000
          });
          this.getPublications();
        }, (error) => {
          this.snackBar.open(`Error adding publication: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

  public editPublication(): void {
    const dialogRef = this.dialog.open(PublicationDialogComponent, {
      width: '1050px',
      data: this.selectedPublication.dataItem
    });

    dialogRef.afterClosed().subscribe(publication => {

      if ( publication ) {
        this.api.patch<any>(`/publication/${publication.id}`, publication).subscribe( result => {
          this.snackBar.open('Publication updated.', null, {
            duration: 2000
          });
          this.getPublications();
        }, (error) => {
          this.snackBar.open(`Error updating publication: ${error}`, null, {
            duration: 2000
          });
        });
      }

      this.selectedPublication = null;
    });
  }

  public removePublication(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      data: { message: 'Remove this publication?', action: 'Remove'}
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if ( confirmed ) {
        this.api.del<any>(`/publication/${this.selectedPublication.dataItem._id}` ).subscribe( result => {
          this.snackBar.open('Publication removed.', null, {
            duration: 2000
          });
          this.getPublications();
        }, (error) => {
          this.snackBar.open(`Error removing publication: ${error}`, null, {
            duration: 2000
          });
        });
      }
      this.selectedPublication = null;
    });
  }

}
